/**
 * @author       grady@zumper.com (Grady Kuhnline <gradykuhnline>)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Renders all modal wrappers
 */

import React from 'react'
import { ModalWrapperContainer } from './ModalWrapperContainer'
import { modals } from './modals/index'

export const AllModals = () =>
  modals.map(({ component, type }) => (
    <ModalWrapperContainer component={component} key={type} type={type} />
  ))
